import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const Browse = () => {
  return (
    <NavigationLayout dataApp='browse-plp'>
      <Layout />
    </NavigationLayout>
  )
}

export default Browse
